<div class="modal-header">
  <h4 class="modal-title">Erinnerung einstellen</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p class="text-muted small mb-3">Erinnerung für: <strong>{{ notificationTitle }}</strong></p>

  <h6>Schnellauswahl</h6>
  <div class="d-flex flex-wrap gap-2 mb-4">
    <button *ngFor="let option of quickOptions"
            class="btn btn-outline-primary btn-sm"
            (click)="selectQuickOption(option)">
      {{ option.label }}
    </button>
  </div>

  <hr>

  <h6>Manuell festlegen</h6>
  <div class="row g-3">
    <div class="col-md-7">
      <label class="form-label small mb-1">Datum</label>
      <div class="input-group input-group-sm">
        <input class="form-control" placeholder="yyyy-mm-dd"
               name="dp" [(ngModel)]="selectedDate" ngbDatepicker #d="ngbDatepicker">
        <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
          <fa-icon [icon]="faCalendarAlt"></fa-icon>
        </button>
      </div>
    </div>
    <div class="col-md-5">
      <label class="form-label small mb-1">Uhrzeit</label>
      <ngb-timepicker [(ngModel)]="selectedTime" [spinners]="false" size="small"></ngb-timepicker>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()">Abbrechen</button>
  <button type="button" class="btn btn-primary btn-sm" (click)="saveManual()">Erinnerung speichern</button>
</div>
